import React, {Component} from 'react'
import {connect} from 'react-redux'
import NavBar from '../../../../_components/common/Navbar';
import Footer from '../../../../_components/common/Footer';
import SettingsHead from '../../../../_components/common/SettingsHead';
import ModalNew2 from '../../../../_components/common/ModalNew2';
import CustomTableNew from '../../../../_components/common/CustomTableNew';
import {CommonBreadCrumb} from '../../../../_components/common/CommonBreadCrumb'
import {LoaderComp} from '../../../../_components/common/LoaderComp/Loadercomp';
import Page404 from '../../../404page';
import {addManageMetricAction} from '../../../../_actions/organisations/ManageMetric/addManageMetric.action';
import {getManageMetricAction} from '../../../../_actions/organisations/ManageMetric/getManageMetricList.action';
import {deleteManageMetricAction} from '../../../../_actions/organisations/ManageMetric/deleteManageMetric.action';
import {updateManageMetricAction} from '../../../../_actions/organisations/ManageMetric/updateManageMetric.action';
import { organisationAction } from '../../../../_actions/organisation.action';




class ManageMatrix extends Component {
    state = {
        addModal: false,

        tableDetails: false,

        tableEdit: false,

        tableDelete: false,

        tableAttrData: [],

        editDataState: {},

        
        editColumnData: [{
            key: 'competency_pre_fill',
            type: 'select',
            value: '',
            selected: false,
            valid: true,
            regex: "^\\d+$",
            elementConfig: {
                name: 'competency_name',
                label: 'Prefill Attributes',
                options: [],
                storeKey: ['CompetencyMetricPrefill', 'data', 'data', 'competency_metrics']
            },
            validation: {
                required: false,
                message: ""
            },
        },{
            key: 'competency_type',
            type: 'select',
            value: '',
            selected: true,
            valid: true,
            regex: "^\\d+$",
            elementConfig: {
                name: 'competency_name',
                label: 'Type',
                options: [],
                storeKey: ['ManageCompetencyList', 'data', 'data', 'compitency_type_list']
            },
            validation: {
                required: true,
                message: ""
            },
        },{
            key: 'competency_name',
            type: 'text',
            value: '',
            valid: true,
            regex: '',
            elementConfig: {
                name: 'competency_name_name',
                label: 'Name',
                placeholder: ''
            },
            validation: {
                required: true,
                message: "is required"
            }
        },{
            key: 'description',
            type: 'text',
            value: '',
            valid: true,
            regex: '',
            elementConfig: {
                name: 'description',
                label: 'Description',
                placeholder: ''
            },
            validation: {
                required: true,
                message: "is required"
            }
        }],

        orgId: 0,


        hasProperOrgId: true,
        idLoader: true,
    }

    componentDidMount() {
        const {dispatch} = this.props;

        let orgIdFromPath = this.props.location.pathname.match(/\d/g);
        orgIdFromPath = orgIdFromPath.join("");
        
        this.setState({
            orgId: orgIdFromPath
        }, () => {
            const {orgId} = this.state;
            dispatch(getManageMetricAction.getCompetencyData())
            dispatch(getManageMetricAction.getAttributeList())
            dispatch(getManageMetricAction.competencyMetricPrefill())

            let hasId = false;
            
            dispatch(organisationAction.getOrganisation((callback_Data)=>{
                for (let i = 0; i < callback_Data.data.organisation_list.length; i++) {
                    const element = callback_Data.data.organisation_list[i];
                    if(element.id == orgId) {
                        hasId = true
                        dispatch(getManageMetricAction.getManageMetricHandler(orgId, 0))
                    }
                }

                this.setState({
                    hasProperOrgId: hasId,
                    idLoader: false,
                })
            }))
            
        })
    }

    addModalToggler(showModal) {
        this.setState({
            addModal: showModal
        })
    }

    addMatrixAction(data) {
       
        const {dispatch} = this.props;

        let attrData = []
        data.data.map(val => {
            attrData.push({
                attribute: val.id !== undefined ? val.id : val.attribute_id,
                competency_weight: val.competency_weight
            })
        })

        let addMatrixData = {
            competency_type: parseInt(data.sellerData.competency_type, 10),
            top_five_name: '',
            competency_name: data.sellerData.competency_name,
            description: data.sellerData.description,
            organisation: parseInt(this.state.orgId, 10),
            compentency_values: attrData,
            default: !!data.sellerData.competency_pre_fill
        }
        
        dispatch(addManageMetricAction.addManageMetricHandler(this.state.orgId, 0, addMatrixData))

    }

    modalOpener(data) {
        
    }

    tableDetailsToggler(bool) {
        this.setState({
            tableDetails: bool,
        })
    }

    tableEditToggler(data) {
        this.setState({
            tableEdit: data
        })
    }

    tableDeleteToggler(data) {
        this.setState({
            tableDelete: data
        })
    }

    tableButton(data, rowData) {
   
        if(data.content === 'DETAILS') {
            this.setState({
                tableAttrData: rowData
            },() => {
                this.tableDetailsToggler(true)
            })
        }else 
        if(data.content === 'EDIT') {
            let editData = {}
            this.props.metricTableData.map(value => {
                if(value == rowData) {
                    this.state.editColumnData.map(val => {
                       if(val.key === 'competency_name') {
                           val.value = value.competency_name
                           val.valid = true
                       }else if(val.key === 'description') {
                            val.value = value.description
                            val.valid = true                            
                        }else if(val.key === 'top_five_name') {
                            val.value = value.top_five_name
                            val.valid = true                            
                        }else if(val.key === 'competency_type') {
                            val.value = value.competency_type__id
                            val.valid = true                            
                        }else if(val.key === 'competency_pre_fill') {
                            val.value = ''
                        }
                    })
                    editData = {...value}
                   
                }
            })
            this.setState({
                editDataState: editData,
                tableAttrData: rowData,
            }, () => {
                this.tableEditToggler(true)
            })
        }else 
        if(data.content === 'DELETE') {
            this.setState({
                tableAttrData: rowData
            }, () => {
                this.tableDeleteToggler(true)
            })
        }
    }

    editMetricAction(data) {
        const {dispatch} = this.props;

      
        let attrData = []
        data.data.map(val => {
            this.props.attributeData.map(value => {
                if(val.attribute__attribute_name === value.attribute_name){
                    attrData.push({
                        attribute: value.id,
                        competency_weight: val.competency_weight
                    })
                }
            })
            
        })

        let editMetricData = {
            competency_type: parseInt(data.sellerData.competency_type, 10),
            top_five_name: '',
            competency_name: data.sellerData.competency_name,
            description: data.sellerData.description,
            organisation: parseInt(this.state.orgId, 10),
            compentency_values: attrData,
            default: !!data.sellerData.competency_pre_fill
        }
        
      
        

        dispatch(updateManageMetricAction.updateManageMetricHandler(this.state.orgId, this.state.tableAttrData.id, editMetricData))

        
    }

    deleteMetricData(data) {
        const {dispatch} = this.props;

        dispatch(deleteManageMetricAction.deleteManageMetricHandler(this.state.orgId, this.state.tableAttrData.id))
    }

    

    render() {
        const {attributeData,metricTableData, metricTableError, metricTableLoading} = this.props
    return (
      <div>
        <NavBar />
            {
                this.state.idLoader ?
                    <div style={{height: 'calc(100vh - 150px)'}} className="container d-flex justify-content-center">
                        <LoaderComp color={'black'} />
                    </div>
                :
                    this.state.hasProperOrgId ? 
                        <div className="container custom-container my-5" >
                            <div style={{marginBottom: 30}}>
                                <CommonBreadCrumb 
                                    data={[
                                        {
                                            link: '/admin/app/dashboard',
                                            name: 'ADMIN'
                                        },{
                                            link: '/admin/app/organisation',
                                            name: 'ORGANISATION'
                                        },{
                                            link: `/admin/app/organisation/${this.state.orgId}`,
                                            name: 'ORGANISATION DETAILS'
                                        },{
                                            link: '',
                                            name: 'MANAGE METRIC'
                                        }
                                    ]}
                                />
                                <div className="bg-green rounded-top animation-fade-in">
                                    
                                    {
                                        (!metricTableError && !metricTableLoading) ?
                                            <p  className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">COMPETENCIES, METRICS, & VALUES </p>                            
                                        :
                                            <div className="d-flex justify-content-between">
                                                <p></p>
                                                <p  className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular">COMPETENCIES, METRICS, & VALUES </p>
                                                <LoaderComp color={'white'} />
                                            </div>
                                    }
                                    <SettingsHead 
                                        buttonData = {[{
                                            id: 1,
                                            heading: "ADD +",
                                            state: this.state.addModal,
                                            toggler: this.addModalToggler.bind(this),
                                        }]}
                                        secondColumn = {false}
                                        deleteAction = { '' }
                                        widthClass = "col-md-12"
                                    />
                                    <CustomTableNew
                                        data={metricTableData}
                                        columns={[{
                                            name: 'Name',
                                            key: 'competency_name',
                                            linkActive: false,
                                            link: '',
                                        },
                                        {
                                            name: 'Description',
                                            key: 'description',
                                            linkActive: false,
                                            link: '',
                                        },
                                        {
                                            name: 'Type',
                                            key: 'competency_type__competency_name',
                                            linkActive: false,
                                            link: '',
                                        },
                                        {
                                            name: 'Details',
                                            key: 'details',
                                            linkActive: false,
                                            link: '',
                                            type: 'button',
                                            content: 'DETAILS',
                                        },
                                        {
                                            name: 'Edit',
                                            key: 'edit',
                                            linkActive: false,
                                            link: '',
                                            type: 'button',
                                            content: 'EDIT',
                                        },
                                        {
                                            name: 'Delete',
                                            key: 'delete',
                                            linkActive: false,
                                            link: '',
                                            type: 'button',
                                            content: 'DELETE',
                                        }]}
                                        showSlNo="false"
                                        modalOpener = {this.modalOpener.bind(this)}
                                        buttonFunc={this.tableButton.bind(this)}
                                    />
                                </div>
                                {
                                    this.state.addModal &&
                                        <ModalNew2
                                            heading="Add Metric/Competency"
                                            showModal={ this.state.addModal }
                                            formData = { [{
                                                key: 'competency_pre_fill',
                                                type: 'select',
                                                value: '',
                                                selected: false,
                                                valid: true,
                                                regex: "^\\d+$",
                                                elementConfig: {
                                                    name: 'competency_name',
                                                    label: 'Prefill Attributes',
                                                    options: [],
                                                    storeKey: ['CompetencyMetricPrefill', 'data', 'data', 'competency_metrics']
                                                },
                                                validation: {
                                                    required: false,
                                                    message: ""
                                                },
                                            },{
                                                key: 'competency_type',
                                                type: 'select',
                                                value: '',
                                                selected: false,
                                                valid: true,
                                                regex: "^\\d+$",
                                                elementConfig: {
                                                    name: 'competency_name',
                                                    label: 'Type',
                                                    options: [],
                                                    storeKey: ['ManageCompetencyList', 'data', 'data', 'compitency_type_list']
                                                },
                                                validation: {
                                                    required: true,
                                                    message: ""
                                                },
                                            },{
                                                key: 'competency_name',
                                                type: 'text',
                                                value: '',
                                                valid: false,
                                                regex: '',
                                                elementConfig: {
                                                    name: 'competency_name',
                                                    label: 'Name',
                                                    placeholder: ''
                                                },
                                                validation: {
                                                    required: true,
                                                    message: "is required"
                                                }
                                            },{
                                                key: 'description',
                                                type: 'text',
                                                value: '',
                                                valid: false,
                                                regex: '',
                                                elementConfig: {
                                                    name: 'description',
                                                    label: 'Description',
                                                    placeholder: ''
                                                },
                                                validation: {
                                                    required: true,
                                                    message: "is required"
                                                }
                                            }] }
                                            bottomTable = {{
                                                type: 'MATRIX_FORM',
                                                data: {
                                                    type: 'ADD',
                                                    data: []
                                                },
                                                attributeList: attributeData
                                            }}
                                            action={ this.addMatrixAction.bind(this) }
                                            toggleModal = { this.addModalToggler.bind(this) }
                                            viewMessage = { [{text: ''}] }
                                            triggerType = { "ADD" }
                                            noReset = {'noReset'}
                                        />
                                }
                                {
                                    this.state.tableDetails &&
                                        <ModalNew2 
                                            heading="Competency - DETAILS"
                                            showModal={ this.state.tableDetails }                                
                                            formData = { [] }
                                            bottomTable = {{
                                                type: 'MATRIX_FORM',
                                                data: {
                                                    type: 'DETAILS',
                                                    data: this.state.tableAttrData.competency_values
                                                },
                                                attributeList: attributeData                                    
                                            }}
                                            metricDetails = {true}
                                            action={(data) => {}}
                                            toggleModal = {this.tableDetailsToggler.bind(this)}
                                            viewMessage = { [{text: ''}] }
                                            triggerType = { 'OK' }
                                        />
                                }
                               
                                {
                                    this.state.tableEdit &&
                                    <ModalNew2
                                        heading="Edit Metric/Competency/Value"
                                        showModal={ this.state.tableEdit }
                                        formData = { this.state.editColumnData }
                                        bottomTable = {{
                                            type: 'MATRIX_FORM',
                                            data: {
                                                type: 'EDIT',
                                                editDataState: this.state.editDataState,
                                                data: this.state.tableAttrData.competency_values,
                                                metricDataForEdit: this.state.tableAttrData.competency_values
                                            },
                                            attributeList: attributeData
                                        }}
                                        action={ (data) => this.editMetricAction(data) }
                                        toggleModal = { this.tableEditToggler.bind(this) }
                                        viewMessage = { [{text: ''}] }
                                        triggerType = { "EDIT" }
                                    />
                                }
                                {
                                    this.state.tableDelete &&
                                        <ModalNew2 
                                            heading="Delete Metric/Competency/Value"
                                            showModal = {this.state.tableDelete}
                                            formData = {[]}
                                            action = {(data) => this.deleteMetricData(data)}
                                            toggleModal = {this.tableDeleteToggler.bind(this)}
                                            viewMessage = { [{text: ''},{text: 'Are you Sure?'}] }
                                            triggerType = { "DELETE" }
                                        />
                                }
                            </div>
                        </div>
                    :
                        <Page404 />
            }
            
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = state => {
    const metricTableError = state.ManageMetricList.error;
    const metricTableLoading = state.ManageMetricList.getManageMetricLoading;    
    const metricTableData = (!metricTableError && !metricTableLoading) ? state.ManageMetricList.data.data.organisation_compitency_metric_list : []

    const attributeError = state.ManageAttributeList.error;
    const attributeLoading = state.ManageAttributeList.getAttributeLoading;    
    const attributeData = (!attributeError && !attributeLoading) ? state.ManageAttributeList.data.data.attributes_list : []

    return {
        metricTableData,
        metricTableError,
        metricTableLoading,

        attributeData,
        attributeError,
        attributeLoading,

    }
}

export default connect(mapStateToProps)(ManageMatrix)


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/DetailLinks/manageMatrix.js